import { render, staticRenderFns } from "./trainingParticipationsView.vue?vue&type=template&id=299c245f"
import script from "./trainingParticipationsView.vue?vue&type=script&lang=js"
export * from "./trainingParticipationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports